// © 2026 Camp Promethean, LLC. All Rights Reserved.

/** Default landing for personal free-tier accounts (no paid seat). */
export const FREE_TIER_HOME_PATH = "/arca/calculator";

/** Arca tools available on personal free accounts — all other app areas require a paid plan. */
export const FREE_TIER_ARCA_TOOL_PATHS = [
  "/arca/calculator",
  "/arca/converter",
  "/arca/chemical",
  "/arca/photothermal",
  "/arca/light-lab",
  "/arca/targets",
  "/arca/irrigation-forecaster",
  "/arca/ppms",
] as const;

const ACCOUNT_PATH_PREFIXES = ["/profile", "/pricing", "/welcome", "/join", "/getting-started", "/help", "/facility"] as const;

export function isFreeTierArcaToolPath(path: string): boolean {
  return FREE_TIER_ARCA_TOOL_PATHS.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}

export function isFreeTierAccountPath(path: string): boolean {
  return ACCOUNT_PATH_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}

export function isFreeTierAllowedPath(path: string): boolean {
  return isFreeTierArcaToolPath(path) || isFreeTierAccountPath(path);
}
